import React from 'react';
import Menu from './components/Menu';
import Convite from './components/Convite';
import Sobre from './components/Sobre';
import Slider from './components/Slider';
import Depoimentos from './components/Depoimentos';
import Slogan from './components/Slogan';
import Inscricao from './components/Inscricao';
import Contato from './components/Contato';
import Rodape from './components/Rodape';

import './style/bootstrap.css';
import './style/font-awesome.css';
import './style/animate.css';
import './style/style-blue.css';
import './style/buttons.css';

function App() {
  return (
    <div>
      <header id="home">
        <div id="fb-root"></div>
        <Menu />
      </header>

      <section role="main" className="content">
        <Convite />
        <Sobre />
        <Slider />
        <Depoimentos />
        <Slogan />
        <Inscricao />
        <Contato />
      </section>

      <footer>
        <Rodape />
      </footer>
    </div>
  );
}

export default App;
